import React, { FC } from 'react';
import { AllieCard } from '../Card';
import { StyledContainer, StyledWidgetCard } from './WidgetCard.styles';

interface AllieWidgetCardProps {
  children: React.ReactNode;
}

export const AllieWidgetCard: FC<AllieWidgetCardProps> = ({ children }) => {
  return (
    <StyledContainer>
      <StyledWidgetCard
        content={{
          style: { margin: 0, padding: 'unset 12px' },
          children,
        }}
      />
    </StyledContainer>
  );
};
